import * as React from 'react';

import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import { FieldProps, FieldRenderProps, FormSpy } from 'react-final-form';
import FormGroup from '@material-ui/core/FormGroup';
import SimpleAsyncDropdown from './SimpleAsyncDropdown';
import styles from './AsyncDropdown.module.styl';
import TextField from '@material-ui/core/TextField';

interface IProps {
  title: string;
  name: string;
}

type IOwnProps = IProps &
  FieldProps<string, FieldRenderProps<string, HTMLElement>>;

interface IState {
  type: string;
}

export class AsyncDropdown extends React.Component<IOwnProps, IState> {
  state = {
    type: '',
  };

  private readonly handleValues = (callBack: any) => ({ values }: any) => {
    if (this.state.type === values.type) {
      return;
    }

    this.setState({ type: values.type });
  };

  public render() {
    return this.renderField();
  }

  private renderField = (): React.ReactNode => {
    const { meta, input } = this.props;

    return (
      <FormGroup>
        <FormControl
          className={styles.root}
          error={Boolean(meta.touched && meta.error)}
        >
          {this.getComponent()}

          <FormHelperText>
            {meta.touched && meta.error && <span>{meta.error}</span>}
          </FormHelperText>
        </FormControl>
        <FormSpy
          subscription={{ values: true }}
          onChange={this.handleValues(input.onChange)}
        />
      </FormGroup>
    );
  };

  private getComponent = () => {
    const { title, input } = this.props;

    switch (this.state.type) {
      case 'parent':
        return (
          <TextField
            id={`outlined-with-placeholder${input.name}`}
            label={title}
            placeholder={title}
            margin="normal"
            onChange={this.onChange}
            variant="outlined"
            fullWidth={true}
            value={input.value}
            type="text"
            autoComplete="off"
          />
        );
      case 'page':
      case 'category':
        return (
          <SimpleAsyncDropdown
            label={title}
            onChange={this.onChange}
            value={input.value}
            type={this.state.type}
          />
        );
      default:
        return (
          <TextField
            id={`outlined-with-placeholder${input.name}`}
            label="Please choose the type"
            placeholder="Please choose the type"
            margin="normal"
            disabled={true}
            value=""
            onChange={this.onChange}
            variant="outlined"
            fullWidth={true}
            type="text"
            autoComplete="off"
          />
        );
    }
  };

  onChange = (value: any) => {
    this.props.input.onChange(value);
  };
}
